"use client";

import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import resourcesToBackend from "i18next-resources-to-backend";
import { useEffect } from "react";
import { initReactI18next, useTranslation as useTranslationOrg } from "react-i18next";
import { getOptions, languages } from "@/i18n/settings";

const runsOnServerSide = typeof window === "undefined";

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(
    resourcesToBackend(
      (language: string, namespace: string) =>
        import(`@/i18n/locales/${language}/${namespace}.json`)
    )
  )
  .init({
    ...getOptions(),
    lng: undefined,
    detection: {
      order: ["path"],
    },
    preload: runsOnServerSide ? languages : [],
  });

export function useTranslation(ns: string, lng?: string, options?: object) {
  const translationOrg = useTranslationOrg(ns, options);
  const { i18n } = translationOrg;

  // Only handle language change if lng is provided and different
  useEffect(() => {
    if (lng && i18n.resolvedLanguage !== lng) {
      i18n.changeLanguage(lng);
    }
  }, [i18n, lng]);

  return translationOrg;
}
